
export default ({ params }) => {
    return <div>Unknown element: {params.join(' | ')}</div>;
};
